<template>
  <div>
    <div v-if="summary">
      <mdb-tbl hover sm v-if="summary.NCS.length">
        <mdb-tbl-head>
          <tr class="title" >
            <th>NCS 교과명</th>
            <th>수행 진단</th>
            <th>수행1</th><th>수행2</th><th>필답1</th><th>필답2</th><th>태도</th><th>포트폴리오</th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <template v-for="s in summary.NCS">
            <tr :key="s._id">
              <td colspan="8" class="bolder pointer" @click="onViewPlan(s)">
                <mdb-icon  icon="chalkboard-teacher" /> {{s.name}}
              </td>
            </tr>
            <tr v-for="l in s.lectures" :key="l._id">
              <td class="pl-4">
                <mdb-icon  icon="chalkboard" /> {{l.name}}
                <mdb-badge v-if="l.portfolio">포트폴리오</mdb-badge>
              </td>
              <!-- 수행진단평가 -->
              <td style="width:80px">
                <mdb-btn v-if="l.result.self" color="success" class="w-90 p-0 m-0"
                  @click="onViewSelfPerformResult(l.result.self)">결과보기</mdb-btn>
                <mdb-btn v-else color="primary" class="w-90 p-0 m-0"
                  @click="onTakeSelfPerformTest(l.code)">응시하기</mdb-btn>
              </td>
              <!-- 수행 -->
              <td class="px-0" style="width:80px">
                <student-test-result :result="l.result.perform[1]"
                  @view-result="onViewPerformResult(l.result.perform[1])" @take-test="onTakePerformTest(l.result.perform[1].test, 1)"/></td>
              <td class="px-0" style="width:80px">
                <student-test-result v-if="isRetry(l.result.perform[1])" :result="l.result.perform[2]"
                  @view-result="onViewPerformResult(l.result.perform[2])" @take-test="onTakePerformTest(l.result.perform[2].test, 2)"/></td>
              <!-- 필답 -->
              <td class="px-0" style="width:80px">
                <student-test-result :result="l.result.writing[1]"
                  @view-result="onViewWritingResult(l.result.writing[1])" @take-test="onTakeWritingTest(l.result.writing[1].test, 1)"/></td>
              <td class="px-0" style="width:80px">
                <student-test-result v-if="isRetry(l.result.writing[1])" :result="l.result.writing[2]"
                  @view-result="onViewWritingResult(l.result.writing[2])" @take-test="onTakeWritingTest(l.result.writing[2].test, 2)"/></td>
              <!-- 태도 -->
              <td class="px-0" style="width:80px">
                <mdb-btn :color="color(l.result.attitude.score)" v-if="l.result.attitude.score" class="w-90 p-0 m-0"
                  @click="onViewAttitudeResult(l.result.attitude)">{{l.result.attitude.score}}점</mdb-btn></td>
              <!-- 포트폴리오 -->
              <td class="px-0" style="width:90px">
                <student-test-result v-if="l.portfolio" :result="l.result.portfolio"
                  @view-result="onViewPortfolioResult(l.result.portfolio)" @take-test="onTakePortfolioTest(l.result.portfolio.test)"/></td>
            </tr>
          </template>
        </mdb-tbl-body>
      </mdb-tbl>
      <mdb-tbl hover sm v-if="summary.NONNCS.length">
        <mdb-tbl-head>
          <tr class="title" >
            <th>비 NCS 교과명</th><th>수행1</th><th>수행2</th><th>필답1</th><th>필답2</th><th>태도</th>
            <th style="font-size:1em">포트폴리오</th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr v-for="s in summary.NONNCS" :key="s._id">
            <td class="bolder pointer" @click="onViewPlan(s)">
              <mdb-icon  icon="chalkboard-teacher" /> {{s.name}}
              <mdb-badge v-if="s.portfolio">포트폴리오</mdb-badge>
            </td>
            <!-- 수행 -->
            <td class="px-0" style="width:80px">
              <student-test-result  :result="s.result.perform[1]"
                @view-result="onViewPerformResult(s.result.perform[1])" @take-test="onTakePerformTest(s.result.perform[1].test, 1)"/></td>
            <td class="px-0" style="width:80px">
              <student-test-result v-if="isRetry(s.result.perform[1])" :result="s.result.perform[2]"
                @view-result="onViewPerformResult(s.result.perform[2])" @take-test="onTakePerformTest(s.result.perform[2].test, 2)"/></td>
            <!-- 필답 -->
            <td class="px-0" style="width:80px">
              <student-test-result :result="s.result.writing[1]"
                @view-result="onViewWritingResult(s.result.writing[1])" @take-test="onTakeWritingTest(s.result.writing[1].test, 1)"/></td>
            <td class="px-0" style="width:80px">
              <student-test-result v-if="isRetry(s.result.writing[1])" :result="s.result.writing[2]"
                @view-result="onViewWritingResult(s.result.writing[2])" @take-test="onTakeWritingTest(s.result.writing[2].test, 2)"/></td>
            <!-- 태도 -->
            <td class="px-0" style="width:80px">
              <mdb-btn :color="color(s.result.attitude.score)" v-if="s.result.attitude.score" class="w-90 p-0 m-0"
                @click="onViewAttitudeResult(s.result.attitude)">{{s.result.attitude.score}}점</mdb-btn></td>
            <!-- 포트폴리오 -->
            <td class="px-0" style="width:90px">
              <student-test-result v-if="s.portfolio" :result="s.result.portfolio"
                @view-result="onViewPortfolioResult(s.result.portfolio)" @take-test="onTakePortfolioTest(s.result.portfolio.test)"/></td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
    </div>
    <modal-dlg v-if="modal" size="lg" icon="chalkboard-teacher" :title="subject.name" :show="modal"  @close="onClose">
      <subject-plan :plan="subject.plan" :lectures="subject.lectures"/>
      <div class="text-center"><mdb-btn class="py-2" @click="onClose">닫기</mdb-btn></div>
    </modal-dlg>
  </div>
</template>
<script>
import { mdbIcon, mdbBtn } from 'mdbvue';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Summary from '@/models/Summary'
import StudentTestResult from './StudentTestResult.vue';
import ModalDlg from '../common/ModalDlg.vue';
import SubjectPlan from '../subject/SubjectPlan.vue';
export default {
  components: { StudentTestResult, ModalDlg, SubjectPlan },
  name: 'StduentSummary',
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('training', ['training']),
    ...mapGetters('training', ['failScore'])
  },
  data () {
    return {
      summary: undefined, // 결과 요약 데이터
      subject: undefined, // 계획서 보기할 과목
      modal: false // 대화상자 제어
    }
  },
  methods: {
    // 재평가 대상인지 여부
    isRetry (result) {
      return result && result.score >= 0 && result.score < this.failScore
    },
    async load () {
      const training = this.training._id
      const student = this.profile._id
      if (training && student) {
        this.summary = await Summary.getByStudent(training, student)
      }
    },
    color (score) {
      if (!score) return
      return score < this.failScore ? 'danger' : 'success'
    },
    // 계획서 보기
    onViewPlan (s) {
      this.subject = s
      this.modal = true
    },
    // 계획서 닫기
    onClose () {
      this.modal = false
      this.subject = undefined
    },
    // 수행 자가 진단
    onViewSelfPerformResult (answer) {
      this.$router.push({
        name: 'StudentPerformSelfTestView',
        query: { answer }
      })
    },
    onTakeSelfPerformTest (code) {
      this.$router.push({
        name: 'StudentPerformSelfTestExam',
        query: { code }
      })
    },
    // 수행평가
    onViewPerformResult (info) {
      const { test, answer } = info
      this.$router.push({
        name: 'StudentPerformTestView',
        query: { test, answer }
      })
    },
    onTakePerformTest (test, seq) {
      if (!test) return alert('등록된 평가가 없습니다...')
      this.$router.push({
        name: 'StudentPerformTestExam',
        query: { test, seq }
      })
    },
    onViewWritingResult (info) {
      const { test, answer } = info
      this.$router.push({
        name: 'StudentWritingTestView',
        query: { test, answer }
      })
    },
    onTakeWritingTest (test, seq) {
      if (!test) return alert('등록된 평가가 없습니다...')
      this.$router.push({
        name: 'StudentWritingTestExam',
        query: { test, seq }
      })
    },
    onViewAttitudeResult (info) {
      const { test, answer } = info
      this.$router.push({
        name: 'StudentAttitudeTestView',
        query: { test, answer }
      })
    },
    onViewPortfolioResult (info) {
      const { test, answer } = info
      this.$router.push({
        name: 'StudentPortfolioTestView',
        query: { test, answer }
      })
    },
    onTakePortfolioTest (test) {
      if (!test) return alert('등록된 평가가 없습니다...')
      this.$router.push({
        name: 'StudentPortfolioTestExam',
        query: { test }
      })
    }
  },
  watch: {
    training () { this.load() }
  },
  created () { this.load() }
}
</script>
